import { WorkspaceSection } from "@dewo/app/graphql/types";
import { useRunning } from "@dewo/app/util/hooks";
import { Button, Input, Popover, Row, Space } from "antd";
import React, { FC, useCallback, useState } from "react";
import { useUpdateWorkspaceSection } from "./hooks";

export const RenameWorkspaceSectionPopover: FC<{
  visible: boolean;
  onClose: () => void;
  organizationId: string;
  section: WorkspaceSection;
}> = ({ visible, onClose, section, organizationId }) => {
  const [name, setName] = useState(section.name);
  const update = useUpdateWorkspaceSection();

  const [handleUpdate, updating] = useRunning(
    useCallback(async () => {
      await update({
        name,
        organizationId,
        id: section.id,
      });
      onClose();
    }, [name, onClose, organizationId, section.id, update])
  );

  return (
    <Popover
      visible={visible}
      trigger="click"
      onVisibleChange={onClose}
      content={
        <Space direction="vertical" style={{ padding: 8 }}>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            placeholder="Change section name"
            onPressEnter={handleUpdate}
          />
          <Row style={{ gap: 8 }}>
            <Button
              loading={updating}
              disabled={updating}
              type="primary"
              size="small"
              style={{ flex: 1 }}
              onClick={handleUpdate}
            >
              Update
            </Button>
          </Row>
        </Space>
      }
    ></Popover>
  );
};
